import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Sign up", -1)
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_1,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Display name",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.displayName) = $event))
      }, null, 512), [
        [_vModelText, $setup.displayName]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "email",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event))
      }, null, 512), [
        [_vModelText, $setup.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Password",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event))
      }, null, 512), [
        [_vModelText, $setup.password]
      ]),
      ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($setup.error), 1))
        : _createCommentVNode("", true),
      (!$setup.isPending)
        ? (_openBlock(), _createElementBlock("button", _hoisted_3, "Sign up"))
        : _createCommentVNode("", true),
      ($setup.isPending)
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, "Loading"))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}